import { useAuth0 } from '@auth0/auth0-react';
import { AttachMoneySharp, CategorySharp, ChecklistRtlSharp, SellSharp, WhatsApp, ShoppingCartCheckoutSharp, AssessmentSharp, RestartAltSharp, AdminPanelSettingsSharp, LocalOfferSharp, BarChartSharp, DashboardSharp, PointOfSaleSharp, ConfirmationNumberOutlined, CreditCardSharp, PrintSharp, ReceiptLongSharp, PaymentsSharp } from '@mui/icons-material';
import { Box, CssBaseline } from '@mui/material';
import { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import { CustomDrawer, Header } from './components';
import { useMiContexto } from './components/base/ContextProvider';
import { useCurrentUser } from './components/base/UserProvider';
import ProtectedRoute from './components/base/ProtectedRoute';
import { TabsProvider, useTabs } from './components/base/TabsProvider';
import TabsManager from './components/TabsManager';
import Articles from './screens/articulos/Articles';
import ArticulosPage from './screens/articulos/Articulos';
import PublicacionesPage from './screens/articulos/Publications';
import CategoriasPage from './screens/categorias/Categorias';
import Home from './screens/home/home';
import MovimientosPage from './screens/movimientos/Movimientos';
import RecuperarPage from './screens/movimientos/Recuperar';
import PedidosPage from './screens/pedidos/Pedidos';
import VentasPage from './screens/ventas/Ventas';
import AnalisisPage from './screens/analisis/Analisis';
import AdminPage from './screens/analisis/Admin';
import OfertasPage from './screens/ofertas/Ofertas';
import StatsPage from './screens/stats';
import DashboardPage from './screens/dashboard';
import CajeroPage from './screens/cajero/Cajero';
import RifaPage from './screens/rifa/Rifa';
import storeService from './services/stores';
import UserService from './services/user';
import PaymentTypesAdmin from './screens/paymenttypes/PaymentTypesAdmin';
import PrinterSettingsPage from './screens/settings/PrinterSettingsPage';
import TicketsDashboard from './screens/tickets';
import PayrollPage from './screens/payroll';
import ChatPage from './screens/chat/ChatPage';
import { WhatsappSessionsProvider } from './components/base/WhatsappSessionsProvider';

function AppContent() {
  const location = useLocation();
  const { isAuthenticated, logout, isLoading, user } = useAuth0();
  const { setValor } = useMiContexto();
  const { isAdmin, currentUser, setCurrentUser } = useCurrentUser();
  const { addTab, tabs } = useTabs();
  const [stores, setStores] = useState('');
  const [options, setOptions] = useState([]);
  const [Childs, setChilds] = useState(null);
  // Ref para abrir el tab inicial una sola vez por sesión
  const initialTabAdded = useRef(false);

  // Mapa de rutas a componentes — useMemo evita recrear los elementos JSX en cada render
  const routeComponents = useMemo(() => ({
    '/articulos': <ArticulosPage />,
    '/publicaciones': <PublicacionesPage />,
    '/ventas': <VentasPage />,
    '/pedidos': <PedidosPage />,
    '/movimientos': <MovimientosPage />,
    '/ofertas': <OfertasPage />,
    '/categorias': <CategoriasPage />,
    '/dashboard': <DashboardPage />,
    '/cajero': <CajeroPage />,
    '/rifa': <RifaPage />,
    '/estadisticas': <StatsPage />,
    '/analisis': <AnalisisPage />,
    '/admin': <AdminPage />,
    '/recuperar': <RecuperarPage />,
    '/medios-pago': <PaymentTypesAdmin />,
    '/impresoras': <PrinterSettingsPage />,
    '/tickets': <TicketsDashboard />,
    '/payroll': <PayrollPage />,
  }), []);

  const loadStores = useCallback(async () => {
    console.log("Se inicia a buscar stores");
    const resp = await storeService.getAll();
    console.log(resp);
    setStores(resp);
    setValor(resp);
  }, [setValor]);

  useEffect(() => {
    if (!isAuthenticated || !user || currentUser) return;
    const storeUserLogged = async () => {
      const userToStore = {
        name: user.given_name,
        last_name: user.family_name,
        email: user.email,
        picture: user.picture,
        auth_sub: user.sub,
      };
      try {
        const aux = await UserService.save(userToStore);
        console.log('aux completo:', aux);
        console.log('aux.data:', aux?.data);
        const savedUser = aux?.data || await UserService.getByAuthSub(user.sub);
        if (savedUser) setCurrentUser(savedUser);
      } catch (err) {
        console.error('Error storing user:', err);
      }
    };
    storeUserLogged();
  }, [isAuthenticated, user, currentUser, setCurrentUser]);

  // Abre el tab de Artículos automáticamente al autenticarse, una sola vez por sesión.
  // Esto evita que Articles.jsx (en la ruta /) y Articulos.jsx (en el tab) carguen
  // los artículos simultáneamente cuando el usuario abre el tab por primera vez.
  useEffect(() => {
    if (isAuthenticated && !initialTabAdded.current) {
      initialTabAdded.current = true;
      addTab({
        title: 'Articulos',
        path: '/articulos',
        icon: <SellSharp />,
        component: routeComponents['/articulos'],
      });
    }
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const isFirstVisit = localStorage.getItem('isFirstVisit');
    if (!isFirstVisit) {
      localStorage.clear();
      localStorage.setItem('isFirstVisit', 'true');
    }
    if (!stores) {
      loadStores();
    } else {
      setValor(stores);
    }
  }, [stores, setValor, loadStores])

  const onExit = () => {
    console.log(isLoading)
    logout({ returnTo: window.location.origin })
    console.log(isLoading)
  }

  const handleTabClick = (tabData) => {
    const component = routeComponents[tabData.path];
    if (component) {
      addTab({
        ...tabData,
        component
      });
    }
  };

  const allMenuOptions = [
    { tittle: 'Articulos',    path: '/articulos',    icon: <SellSharp /> },
    { tittle: 'Publicaciones', path: '/publicaciones', icon: <WhatsApp /> },
    { tittle: 'Ventas',       path: '/ventas',       icon: <ShoppingCartCheckoutSharp /> },
    { tittle: 'Cajero',       path: '/cajero',       icon: <PointOfSaleSharp /> },
    { tittle: 'Rifa',         path: '/rifa',         icon: <ConfirmationNumberOutlined /> },
    { tittle: 'Pedidos',      path: '/pedidos',      icon: <ChecklistRtlSharp />},
    { tittle: 'Movimientos',  path: '/movimientos',  icon: <AttachMoneySharp /> },
    { tittle: 'Medios de pago', path: '/medios-pago', icon: <CreditCardSharp />, adminOnly: true },
    { tittle: 'Impresoras',     path: '/impresoras',  icon: <PrintSharp />,     adminOnly: true },
    { tittle: 'Tickets',        path: '/tickets',     icon: <ReceiptLongSharp />, adminOnly: true },
    { tittle: 'Payroll',        path: '/payroll',     icon: <PaymentsSharp />, adminOnly: false },
    { tittle: 'Ofertas',      path: '/ofertas',      icon: <LocalOfferSharp />, adminOnly: true },    { tittle: 'Categorías',    path: '/categorias',   icon: <CategorySharp />, adminOnly: true },    { tittle: 'Dashboard',    path: '/dashboard',    icon: <DashboardSharp />, adminOnly: true },
    { tittle: 'Estadísticas', path: '/estadisticas', icon: <BarChartSharp />, adminOnly: true },
    { tittle: 'Analisis',     path: '/analisis',     icon: <AssessmentSharp />, adminOnly: true },
    { tittle: 'Administrar',  path: '/admin',        icon: <AdminPanelSettingsSharp />, adminOnly: true },
    { tittle: 'Recuperar',    path: '/recuperar',    icon: <RestartAltSharp />, adminOnly: true },
  ];

  const menuOptions = allMenuOptions.filter(o => isAdmin || !o.adminOnly);

  const MenuDesplegable = () =>
    <Box display='flex' flexDirection='row' alignItems='center' width='100%'>
      {isAuthenticated && <CustomDrawer options={menuOptions}
        onExit={onExit}
        onTabClick={handleTabClick}
      />}
      {Childs}
    </Box>;

  if (location.pathname === '/chat') {
    return <ChatPage />;
  }

  return (
    <>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100vw', overflow: 'hidden' }}>
        <Header Child={MenuDesplegable} options={options} />
        <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {isAuthenticated && tabs.length > 0 ? (
            <TabsManager stores={stores} setOptions={setOptions} setChilds={setChilds} />
          ) : (
            <Routes>
              <Route path='/' element={<Articles store={stores && stores[0]} setOptions={setOptions} setChildHeader={setChilds}/>} />
              <Route path='/login' element={<Home setOptions={setOptions} setChildHeader={setChilds} />} />
              <Route path='/categorias' element={<ProtectedRoute component={<CategoriasPage />} />} />
            </Routes>
          )}
        </Box>
      </Box>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <WhatsappSessionsProvider>
        <TabsProvider>
          <AppContent />
        </TabsProvider>
      </WhatsappSessionsProvider>
    </BrowserRouter>
  );
}

export default App;
